<template>
  <div style="padding-bottom: 50px">
    <ion-grid fixed>
      <ion-icon :src="require('@lib/assets/icons/roodie.svg')" size="large" />

      <ion-row class="ion-margin-top">
        <ion-col>
          <b>Ihr Roodie.Check</b>
          <div>Eine Zusammenfassung Ihrer Antworten</div>
          <div>
            {{ timestamp }}
          </div>
        </ion-col>
        <!-- <ion-col class="ion-text-right">
          <ion-button
            fill="clear"
            size="large"
            class="ion-no-padding ion-margin-start"
            @click="window.location.reload()"
            ><ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_neuestart.svg')"
              slot="icon-only"
          /></ion-button>
          <ion-button
            fill="clear"
            size="large"
            class="ion-no-padding ion-margin-start"
            ><ion-icon
              size="large"
              :src="require('@lib/assets/icons/print-circle.svg')"
              slot="icon-only"
          /></ion-button>
          <ion-button
            fill="clear"
            size="large"
            class="ion-no-padding ion-margin-start"
            ><ion-icon
              size="large"
              :src="require('@lib/assets/icons/download-circle.svg')"
              slot="icon-only"
          /></ion-button>
        </ion-col> -->
      </ion-row>

      <ion-row>
        <ion-col class="ion-text-right">
          <!-- <ion-button fill="outline" @click="window.location.reload()"
        >Neu Starten</ion-button
      > -->

          <!-- <ion-button @click="submit">Teilen mit {{ name }}</ion-button> -->
          <ion-button @click="deleteRoodieCheck" fill="clear"
            ><ion-icon slot="icon-only" :icon="trashOutline"></ion-icon
          ></ion-button>
          <ion-button @click="next" fill="outline">Weiter</ion-button>

          <!-- @checked="isPrivacyChecked = true" -->
        </ion-col>
      </ion-row>

      <!-- <div class="ion-text-right ion-margin-top ion-padding-top">
      <ion-button @click="submit">Teilen mit {{ name }}</ion-button>
    </div>
    <div class="ion-text-right">
      
      <ion-button fill="outline" @click="window.location.reload()"
        >Neu Starten</ion-button
      >
    </div> -->

      <ion-grid class="ion-margin-top">
        <ion-row
          class="ion-align-items-center"
          v-if="this.selectedCondition.name !== 'toothAppointment'"
        >
          <ion-col size="10" :offset="shouldOpenInteliwiseModal ? 0 : 2"
            >Sagen Sie uns, was Ihnen fehlt oder was Sie brauchen:</ion-col
          >
          <ion-col
            size="2"
            class="ion-text-center"
            v-if="!shouldOpenInteliwiseModal"
          >
            <ion-button
              @click="$emit('back-to-search')"
              fill="clear"
              class="ion-no-padding"
            >
              <ion-icon
                slot="icon-only"
                :src="require('@lib/assets/icons/pencil-circle.svg')"
              ></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col size="10">
            <ion-text
              @click="
                shouldOpenInteliwiseModal ? null : $emit('back-to-search')
              "
              color="primary"
              v-html="selectedSentence"
              class="u-cursor-pointer"
            ></ion-text>
          </ion-col>
          <ion-col size="10" :offset="shouldOpenInteliwiseModal ? 0 : 2">
            <div class="c-line -short"></div>
          </ion-col>
        </ion-row>
        <template v-for="(question, questionIndex) in filteredQuestions">
          <ion-row
            v-if="answersObject[question.id]"
            :key="question.id"
            class="ion-align-items-center"
          >
            <ion-col
              size="10"
              :offset="shouldOpenInteliwiseModal ? 0 : 2"
              v-html="getQuestionText(question)"
            >
            </ion-col>
            <ion-col
              size="2"
              class="ion-text-center"
              v-if="!shouldOpenInteliwiseModal"
            >
              <ion-button
                v-if="!question.isAdditionalQuestion"
                @click="editQuestion(question.id)"
                fill="clear"
                class="ion-no-padding"
              >
                <ion-icon
                  slot="icon-only"
                  :src="require('@lib/assets/icons/pencil-circle.svg')"
                ></ion-icon>
              </ion-button>
            </ion-col>
            <ion-col size="10">
              <ion-text
                @click="editQuestion(question.id)"
                color="primary"
                v-if="!answersObject[question.id].base64"
                v-html="getAnswerValue(question.id)"
                class="u-cursor-pointer"
              ></ion-text>
              <div v-else>
                <img
                  @click="editQuestion(question.id)"
                  height="200"
                  :src="answersObject[question.id].base64"
                  class="u-cursor-pointer"
                />
              </div>
            </ion-col>
            <ion-col
              v-if="!filteredQuestions[questionIndex + 1]?.isAdditionalQuestion"
              size="10"
              :offset="shouldOpenInteliwiseModal ? 0 : 2"
            >
              <div class="c-line -short"></div>
            </ion-col>
          </ion-row>
        </template>
      </ion-grid>

      <div class="ion-text-right">
        <ion-button @click="deleteRoodieCheck" fill="clear"
          ><ion-icon slot="icon-only" :icon="trashOutline"></ion-icon
        ></ion-button>
        <ion-button @click="next">Weiter</ion-button>
      </div>
    </ion-grid>

    <ion-modal
      :is-open="showExplanation || showPersonalData"
      @didDismiss="
        showExplanation = false;
        showPersonalData = false;
        newRouting = '';
      "
    >
      <ion-page>
        <ion-header class="ion-no-border">
          <ion-toolbar color="primary" class="-not-fixed -primary">
            <ion-buttons slot="start">
              <ion-button
                @click="
                  // showExplanation && showPersonalData
                  //   ? (showPersonalData = false)
                  //   :
                  if (newRouting.startsWith('ARAG Case Management')) {
                    openEndModal('cancel').then(() => {
                      showExplanation = false;
                      showPersonalData = false;
                    });
                  } else {
                    modalController.dismiss();
                  }
                "
              >
                <ion-icon
                  :src="require('@lib/assets/icons/icon_zurueck.svg')"
                  slot="icon-only"
                ></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-button
              slot="end"
              @click="modalController.dismiss()"
              fill="clear"
              size="large"
              ><ion-icon
                slot="icon-only"
                :icon="closeOutline"
                size="large"
              ></ion-icon
            ></ion-button>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-grid fixed>
            <div class="ion-margin-bottom">
              <roodie expression="happy" />
            </div>
            <transition :name="showPersonalData ? 'slide-up' : 'slide-down'">
              <!-- <div v-if="!showPersonalData">
                <div v-if="routing === 'BetterDoc'">
                  <b>So geht es weiter...</b>
                  <p>
                    1. Sie haben die Wahl. Ihr Roodie.Check (Zusammenfassung
                    Ihres Anliegens) wird mit Ihrer Zustimmung an unseren
                    langjährig erfahrenen Partner
                    <a href="#" @click.prevent="showBetterDoc()"> BetterDoc </a>
                    übergeben, damit der/die passende Arzt/Klinik für Sie
                    gesucht werden kann. Sie können darauf aber auch verzichten.
                  </p>
                  <p>
                    2. Sollten noch Informationen nötig sein, so kontaktiert Sie
                    das medizinische Fachpersonal von BetterDoc.
                  </p>
                  <p>
                    3. Spätestens nach 48 Stunden erhalten Sie drei Empfehlungen
                    für die Ärzte oder Kliniken, die optimal passen. Inklusive
                    Terminvereinbarung.
                  </p>
                  <p>
                    4. Während der kompletten ärztlichen Behandlung begleitet
                    Sie ein medizinisch geschulter Spezialist von BetterDoc.
                  </p>
                  <p>
                    Das Service ist für Sie kostenlos und umfasst ein
                    Anamnesegespräch und die Suche nach einer/m geeigneten
                    Arzt/Klinik einschließlich Terminvereinbarung.
                  </p>
                </div>
                <div class="ion-text-right">
                  <ion-button fill="clear" @click="openEndModal('cancel')"
                    >Suche beenden</ion-button
                  >
                  <ion-button
                    @click="
                      newRouting = '';
                      showPersonalData = true;
                    "
                    >Weiter</ion-button
                  >
                </div>
              </div> -->
              <div>
                <b>Bitte überprüfen Sie Ihre persönlichen Daten</b>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none">
                      <ion-label position="stacked"
                        >Versicherungsnummer</ion-label
                      >
                      <ion-input
                        placeholder=""
                        v-model="formInput['ExternalId']"
                        disabled
                      ></ion-input>
                    </ion-item>
                    <input-error id="ExternalId" />
                  </ion-col>
                  <ion-col>
                    <ion-item lines="none">
                      <ion-label position="stacked">Anrede</ion-label>
                      <ion-select
                        v-model="formInput['Initials']"
                        placeholder="Frau/Herr"
                        cancel-text="Abbrechen"
                        disabled
                      >
                        <ion-select-option value="F">Frau</ion-select-option>
                        <ion-select-option value="M">Herr</ion-select-option>
                      </ion-select>
                    </ion-item>
                    <input-error id="Initials" />
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">Vorname</ion-label>
                      <ion-input
                        placeholder="Vorname"
                        v-model="formInput['Firstname']"
                        disabled
                      ></ion-input>
                    </ion-item>
                    <input-error id="Firstname" />
                  </ion-col>
                  <ion-col size="12" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">Nachname</ion-label>
                      <ion-input
                        placeholder="Nachname"
                        v-model="formInput['Lastname']"
                        disabled
                      ></ion-input>
                    </ion-item>
                    <input-error id="Lastname" />
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <ion-item lines="none">
                      <ion-label position="stacked">Geburtsdatum</ion-label>
                      <ion-input
                        v-model="formInput['BirthDate']"
                        placeholder="TT.MM.JJJJ"
                        disabled
                      >
                      </ion-input>
                    </ion-item>
                    <input-error id="BirthDate" />
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="4" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">PLZ</ion-label>
                      <ion-input
                        type="number"
                        v-model="formInput['Zip']"
                        disabled
                      ></ion-input>
                    </ion-item>
                    <input-error id="Zip" />
                  </ion-col>
                  <ion-col size="8" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">Ort</ion-label>
                      <ion-input
                        v-model="formInput['City']"
                        autocapitalize="on"
                        disabled
                      ></ion-input>
                    </ion-item>
                    <input-error id="City" />
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">Mobilnummer</ion-label>
                      <ion-input
                        placeholder="+49XXXXXXXXXX"
                        v-model="formInput['Msisdn']"
                      ></ion-input>
                    </ion-item>
                    <input-error id="Msisdn" />
                  </ion-col>
                  <ion-col size="12" size-md>
                    <ion-item lines="none">
                      <ion-label position="stacked">E-Mail Adresse</ion-label>
                      <ion-input
                        placeholder="adresse@mail.com"
                        v-model="formInput['Email']"
                      ></ion-input>
                    </ion-item>
                    <input-error id="Email" />
                  </ion-col>
                </ion-row>
                <ion-item lines="none" class="ion-margin-top">
                  <ion-checkbox slot="start" v-model="formInput['Privacy']">
                  </ion-checkbox>
                  <ion-label class="ion-text-wrap" color="primary">
                    {{ personalDataPrivacyLabel }}
                    <u class="u-bold"
                      ><a
                        href="#"
                        @click.prevent="
                          $browser.open({
                            url: 'https://www.roodie-health.com/arag/datenschutz',
                          })
                        "
                        >Datenschutzinformationen</a
                      ></u
                    >
                    zur Kenntnis. Diese Einwilligung kann von mir jederzeit
                    widerrufen werden.
                    <a
                      href="#"
                      @click.prevent="openInfoModal(personalDataPrivacyText)"
                      style="text-decoration: none"
                      >MEHR</a
                    >
                  </ion-label>
                </ion-item>
                <div class="ion-text-right ion-margin-top">
                  <ion-button fill="clear" @click="openEndModal('cancel')"
                    >Suche beenden</ion-button
                  >
                  <ion-button
                    v-if="newRouting.startsWith('ARAG Case Management')"
                    @click="contactArag()"
                    :disabled="!formInput.Privacy"
                    >Absenden</ion-button
                  >
                  <ion-button
                    v-else
                    @click="openShareModal()"
                    :disabled="!formInput.Privacy"
                    >Weiter</ion-button
                  >
                </div>
              </div>
            </transition>
          </ion-grid>
        </ion-content>
      </ion-page>
    </ion-modal>

    <!-- <ion-modal
      :is-open="showPersonalData"
      @didDismiss="showPersonalData = false"
    >
      <ion-page>
        <ion-header class="ion-no-border">
          <ion-toolbar color="primary" class="-not-fixed -primary">
            <ion-buttons slot="start">
              <ion-button @click="modalController.dismiss()" color="light">
                <ion-icon
                  :src="require('@lib/assets/icons/icon_zurueck.svg')"
                  slot="start"
                ></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-button
              @click="$store.commit('setOpenMenu', true)"
              fill="clear"
              size="large"
              color="light"
              slot="end"
              ><ion-icon
                slot="icon-only"
                :src="require('@lib/assets/icons/menu.svg')"
                size="large"
              ></ion-icon
            ></ion-button>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-grid fixed>
            <div class="ion-margin-bottom">
              <roodie :expression="'happy'" />
            </div>
            <b>Bitte überprüfen Sie Ihre persönlichen Daten</b>
            <ion-row>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Versicherungsnummer</ion-label>
                  <ion-input
                    placeholder=""
                    v-model="formInput['ExternalId']"
                    disabled
                  ></ion-input>
                </ion-item>
                <input-error id="ExternalId" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Anrede</ion-label>
                  <ion-select
                    v-model="formInput['Initials']"
                    placeholder="Frau/Herr"
                    cancel-text="Abbrechen"
                    disabled
                  >
                    <ion-select-option value="F">Frau</ion-select-option>
                    <ion-select-option value="M">Herr</ion-select-option>
                  </ion-select>
                </ion-item>
                <input-error id="Initials" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">Vorname</ion-label>
                  <ion-input
                    placeholder="Vorname"
                    v-model="formInput['Firstname']"
                    disabled
                  ></ion-input>
                </ion-item>
                <input-error id="Firstname" />
              </ion-col>
              <ion-col size="12" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">Nachname</ion-label>
                  <ion-input
                    placeholder="Nachname"
                    v-model="formInput['Lastname']"
                    disabled
                  ></ion-input>
                </ion-item>
                <input-error id="Lastname" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-item lines="none">
                  <ion-label position="stacked">Geburtsdatum</ion-label>
                  <ion-input
                    v-model="formInput['BirthDate']"
                    placeholder="TT.MM.JJJJ"
                    disabled
                  >
                  </ion-input>
                </ion-item>
                <input-error id="BirthDate" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="4" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">PLZ</ion-label>
                  <ion-input
                    type="number"
                    v-model="formInput['Zip']"
                    disabled
                  ></ion-input>
                </ion-item>
                <input-error id="Zip" />
              </ion-col>
              <ion-col size="8" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">Ort</ion-label>
                  <ion-input
                    v-model="formInput['City']"
                    autocapitalize="on"
                    disabled
                  ></ion-input>
                </ion-item>
                <input-error id="City" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">Mobilnummer</ion-label>
                  <ion-input
                    placeholder="+49XXXXXXXXXX"
                    v-model="formInput['Msisdn']"
                  ></ion-input>
                </ion-item>
                <input-error id="Msisdn" />
              </ion-col>
              <ion-col size="12" size-md>
                <ion-item lines="none">
                  <ion-label position="stacked">E-Mail Adresse</ion-label>
                  <ion-input
                    placeholder="adresse@mail.com"
                    v-model="formInput['Email']"
                  ></ion-input>
                </ion-item>
                <input-error id="Email" />
              </ion-col>
            </ion-row>
          </ion-grid>
          <div class="ion-text-right ion-margin-top">
            <ion-button @click="openShareModal()">Weiter</ion-button>
          </div>
        </ion-content>
      </ion-page>
    </ion-modal> -->
  </div>
</template>

<script>
import {
  IonButton,
  IonIcon,
  IonText,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  // IonFab,
  // IonFabButton,
  // IonFabList,
  IonPage,
  IonContent,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  toastController,
  IonLabel,
  IonInput,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonCheckbox,
} from "@ionic/vue";
import { pencilOutline, trashOutline, add, closeOutline } from "ionicons/icons";
import EndModal from "@/components/EndModal";
import ShareModal from "@arag/components/ShareModal";
// import FormContact from "@/components/FormContact";
// import CGMModal from "@/components/CGMModal";
import Coaching from "@/views/Coaching";
// import ModalClose from "@lib/components/ModalClose.vue";
// import Roodie from "@lib/components/svg/Roodie";
// import PrivacyBetterDoc from "@/components/PrivacyBetterDoc";
import AlertModal from "@/components/AlertModal";
import Roodie from "@lib/components/svg/Roodie";
import { saveCheck } from "@/api/roodiecheck";
import InputError from "@/components/InputError";
import { apiGetUser } from "@/api/user";
// import BetterDoc from "@/views/BetterDoc";
import InfoModal from "@lib/components/InfoModal";
import { contact } from "@arag/api/contact";

export default {
  emits: ["back-to-search", "edit-question", "done"],
  components: {
    IonButton,
    IonIcon,
    IonText,
    IonGrid,
    IonRow,
    IonCol,
    // IonFab,
    // IonFabButton,
    // IonFabList,
    IonPage,
    IonContent,
    IonModal,
    IonHeader,
    IonToolbar,
    IonButtons,
    Roodie,
    IonLabel,
    IonInput,
    IonItem,
    InputError,
    IonSelect,
    IonSelectOption,
    IonCheckbox,
  },
  props: {
    files: {
      required: false,
      type: Array,
      default: null,
    },
    userFiles: {
      required: false,
      type: Array,
      default: null,
    },
    partnerFiles: {
      required: false,
      type: Array,
      default: null,
    },
    answers: {
      required: true,
      type: Array,
    },
    questions: {
      required: true,
      type: Array,
    },
    questionsObject: {
      required: true,
      type: Object,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedSentence: {
      required: false,
      type: String,
      default: "",
    },
    routing: {
      required: false,
      type: String,
      default: "",
    },
    zahn: {
      required: false,
      type: Boolean,
      default: false,
    },
    mental: {
      required: false,
      type: Boolean,
      default: false,
    },
    shouldOpenInteliwiseModal: {
      required: false,
      type: Boolean,
      default: false,
    },
    question: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timestamp: "",
      window: window,
      isEndModalOpen: false,
      modalController: modalController,
      showExplanation: false,
      showPersonalData: false,
      newRouting: "",
      formInput: {
        ExternalId: "",
        Initials: "",
        Firstname: "",
        Lastname: "",
        BirthDate: "",
        Zip: "",
        City: "",
        Msisdn: "",
        Email: "",
        Privacy: false,
      },
    };
  },
  watch: {
    newRouting() {
      this.formInput.Privacy = false;
    },
  },
  mounted() {
    const today = new Date();
    const date =
      (today.getDate() < 10 ? "0" : "") +
      today.getDate() +
      "." +
      (today.getMonth() + 1 < 10 ? "0" : "") +
      (today.getMonth() + 1) +
      "." +
      today.getFullYear();

    const time =
      (today.getHours() < 10 ? "0" : "") +
      today.getHours() +
      ":" +
      (today.getMinutes() < 10 ? "0" : "") +
      today.getMinutes();
    this.timestamp = time + " Uhr | " + date;

    this.$store.commit("setShowLoading", true);
    apiGetUser().then(() => {
      this.formInput.ExternalId = this.$store.state.user.ExternalId;
      this.formInput.Initials = this.$store.state.user.Initials;
      this.formInput.Firstname = this.$store.state.user.FirstName;
      this.formInput.Lastname = this.$store.state.user.LastName;
      this.formInput.BirthDate = this.$store.state.user.BirthDate.split("-")
        .reverse()
        .join(".");
      this.formInput.Zip = this.$store.state.user.Zip;
      this.formInput.City = this.$store.state.user.City;
      this.formInput.Msisdn = this.$store.state.user.Msisdn;
      this.formInput.Email = this.$store.state.user.Email;
    });
    // if (this.selectedCondition.name === "toothAppointment") {
    //   this.openEndModal();
    // }
  },
  methods: {
    // async showBetterDoc() {
    //   const modal = await modalController.create({
    //     component: BetterDoc,
    //     componentProps: {
    //       from: "chat",
    //     },
    //   });
    //   return modal.present();
    // },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "",
          text: text,
        },
      });
      return modal.present();
    },
    getAnswerValue(questionId) {
      let result = this.answersObject[questionId].value;
      if (questionId === "zt-4") {
        result = `
          <b>Zahnärztliche Tagesklinik ${this.ztkBookingLocation.name}</b>
          <br />
          ${this.ztkBookingLocation.address.street} ${this.ztkBookingLocation.address.housenumber}
          <br />
          ${this.ztkBookingLocation.address.zip} -
          ${this.ztkBookingLocation.address.city}
        `;
      } else if (this.answersObject[questionId].value === "ZTK") {
        result = "Zahnärztliche Tageskliniken";
      } else if (
        this.answersObject[questionId].value.startsWith("ARAG Case Management")
      ) {
        result = "ARAG Gesundheitsassistenten";
      }
      return result;
    },
    backToSearch() {
      if (!this.shouldOpenInteliwiseModal) {
        this.$emit("back-to-search");
      }
    },
    async deleteRoodieCheck() {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: "Möchten Sie Ihren Roodie.Check wirklich löschen?",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          // window.location.reload();
          this.$store.commit("setResetHomeViewForce", true);
        }
      });
      return modal.present();
    },
    async contactArag() {
      this.$store.commit("setShowLoading", true);
      const contactData = {
        ...this.formInput,
        Routing: this.newRouting,
        Reference: "Anfrage zur Unterstützung",
        Privacy1: this.formInput.Privacy,
        Privacy1Label:
          this.personalDataPrivacyLabel +
          "Datenschutzinformationen zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen werden.",
        Privacy2: false,
        Privacy2Label: "",
      };
      const contactResponse = await contact(contactData);
      if (contactResponse.data.Status === "Success") {
        this.openEndModal();
      }
    },
    async submit() {
      this.$store.commit("setShowLoading", true);
      const response = await saveCheck(this.answers, this.selectedSentence);
      if (response.data.Status === "Success") {
        if (this.ztkBookingAnswer?.value === "Termin anfragen") {
          // this.openFormContact();
          this.openEndModal();
        } else if (this.ztkBookingAnswer?.value === "Termin buchen") {
          // this.openCGMModal();
          this.openEndModal();
        } else {
          this.openEndModal();
        }
        this.$gtm.trackEvent({
          // event: null, // Event type [default = 'interaction'] (Optional)
          category: "Chat - Abschlüsse",
          action: "Geteilt",
          label: this.routing,
          value: 1,
          // noninteraction: false, // Optional
        });
      }
    },
    next() {
      if (this.question) {
        this.$emit("done", {
          value: "Weiter",
          id: this.question.id,
        });
      } else if (this.routing === "BetterDoc") {
        this.showExplanation = true;
      } else if (
        this.routing.startsWith("ARAG Case Management") ||
        this.routing === "Quality Smile"
      ) {
        this.showPersonalData = true;
      } else {
        this.openShareModal();
      }
    },
    async openShareModal() {
      if (
        this.selectedCondition.name === "toothAppointment" ||
        this.routing === "Medgate"
      ) {
        this.submit();
      } else {
        if (!this.formInput.Msisdn || !this.formInput.Email) {
          const modal = await modalController.create({
            component: AlertModal,
            cssClass: "c-autoheight-modal",
            componentProps: {
              message:
                "Bitte geben Sie noch eine gültige Mobilnummer und E-Mail Adresse an, um Sie zu Ihrem Anliegen kontaktieren zu können.",
              // buttons: ["Ja", "Nein"],
            },
          });
          modal.present();
        } else {
          let routingText = this.newRouting || this.routing;
          if (routingText === "ZTK") {
            routingText = "den Zahnärztlichen Tageskliniken";
          } else if (routingText.startsWith("ARAG Case Management")) {
            routingText = "ARAG Gesundheitsassistenten";
          }
          const modal = await modalController.create({
            component: ShareModal,
            // cssClass: "c-autoheight-modal",
            componentProps: {
              routing: this.newRouting || this.routing,
              routingText: routingText,
              answers: this.answers,
              selectedSentence: this.selectedSentence,
              personalData: this.formInput,
              files: this.files,
              userFiles: this.userFiles,
              partnerFiles: this.partnerFiles,
              shouldOpenFormContact: this.shouldOpenFormContact,
              selectedCondition: this.selectedCondition,
            },
          });
          modal.onDidDismiss().then((result) => {
            // this.openEndModal("afterCoaching");
            if (result.data?.submit == "ja" || result.data?.submit == "nein") {
              // if (this.shouldOpenInteliwiseModal) {
              //   if (result.data == "ja") {
              //     this.showPrivacy2Betterdoc = true;
              //   } else {
              //     this.showPrivacy2Betterdoc = false;
              //   }
              //   this.showPrivacyBetterdoc = true;
              // } else {
              if (
                this.routing === "BetterDoc" ||
                this.routing.startsWith("ARAG Case Management") ||
                this.routing.startsWith("Quality Smile") ||
                this.newRouting
              ) {
                this.openEndModal(
                  undefined,
                  result.data?.checkId,
                  result.data?.isCheckSaved
                );
              } else {
                this.submit();
              }
              // }
            }
          });
          return modal.present();
        }
      }
    },
    async openEndModal(routing, checkId, isCheckSaved) {
      const endModalRouting = routing || this.newRouting || this.routing;
      const modal = await modalController.create({
        component: EndModal,
        componentProps: {
          routing: endModalRouting,
          ztkBookingText: this.ztkBookingAnswer?.value,
          shouldOpenCoaching: this.shouldOpenCoaching,
          shouldOpenInteliwiseModal: this.shouldOpenInteliwiseModal,
          shouldOpenFormContact: this.shouldOpenFormContact,
          selectedCondition: this.selectedCondition,
          isCheckSaved: isCheckSaved,
          hasTreatmentplan: this.hasTreatmentplan,
          files: this.files,
          userFiles: this.userFiles,
          partnerFiles: this.partnerFiles,
        },
      });
      modal.onDidDismiss().then((result) => {
        if (!routing && this.ztkBookingAnswer?.value === "Termin buchen") {
          this.openEndModal("afterZTK");
        } else if (!routing && this.shouldOpenCoaching) {
          this.openCoaching();
        } else if (routing === "cancel") {
          if (result.data?.shouldSaveCheck === true) {
            this.$store.commit("setShowLoading", true);
            saveCheck(this.answers, this.selectedSentence).then((response) => {
              if (response.data.Status === "Success") {
                toastController
                  .create({
                    message:
                      "Ihr Roodie.Check wurde in Ihrem Roodie.Safe gespeichert.",
                    duration: 2000,
                  })
                  .then((toast) => {
                    // toast.onDidDismiss().then(() => {
                    //   window.location.reload();
                    // });
                    toast.present();
                    this.$store.commit("setResetHomeViewForce", true);
                  });
              }
            });
          } else if (result.data?.shouldSaveCheck === false) {
            // window.location.reload();
            this.$store.commit("setResetHomeViewForce", true);
          } else if (result.data?.newRouting) {
            this.newRouting = result.data?.newRouting;
            this.showPersonalData = true;
          }
        } else if (
          this.shouldOpenFormContact &&
          endModalRouting !== "ARAG Case Management Mental"
        ) {
          this.$router.push({
            name: "arag-mental",
            query: { checkId: checkId },
          });
          modalController.dismiss();
          this.$emit("back-to-search", true);
        } else if (this.formInput.Email !== "test@gangl.com") {
          // window.location.reload();
          this.$store.commit("setResetHomeViewForce", true);
          if (result.data?.routeName) {
            this.$router.push({
              name: result.data.routeName,
            });
          }
        }
        // this.$store.commit("setShowLoading", false);
      });
      return modal.present();
    },
    async openCoaching() {
      const modal = await modalController.create({
        component: Coaching,
        componentProps: {
          from: "answerSummary",
        },
      });
      modal.onDidDismiss().then(() => {
        this.openEndModal("afterCoaching");
      });
      return modal.present();
    },
    // async openFormContact() {
    //   const modal = await modalController.create({
    //     component: FormContact,
    //     componentProps: {
    //       title: "Persönliche Daten",
    //       showNote: false,
    //       routing: this.routing,
    //       from: "chat",
    //       answers: this.answers,
    //       selectedSentence: this.selectedSentence,
    //     },
    //   });
    //   modal.onDidDismiss().then((result) => {
    //     if (result.data?.isSent) {
    //       this.openEndModal();
    //     }
    //   });
    //   return modal.present();
    // },
    // async openCGMModal() {
    //   const modal = await modalController.create({
    //     component: CGMModal,
    //   });
    //   modal.onDidDismiss().then((result) => {
    //     if (result.data?.isBooked) {
    //       this.openEndModal();
    //     }
    //   });
    //   return modal.present();
    // },
    getQuestionText(question) {
      let result = "";
      if (question?.summary?.text) {
        result = question.summary.text;
      } else if (typeof question.text === "object") {
        if (question.text.zahn && this.zahn) {
          result = question.text.zahn;
        } else if (question.text.all) {
          result = question.text.all;
        }
      } else {
        result = question.text;
      }
      return result;
    },
    editQuestion(id) {
      if (!this.shouldOpenInteliwiseModal) {
        this.$emit("edit-question", id);
      }
    },
  },
  computed: {
    aragRoutingSuffix() {
      let result = "";
      if (this.routing === "ARAG Case Management Zahn") {
        result = "ZAHN";
      } else if (this.routing === "ARAG Case Management Mental") {
        result = "MENTAL";
      }
      return result;
    },
    effectiveRouting() {
      return this.newRouting || this.routing;
    },
    personalDataPrivacyLabel() {
      let result = "";
      if (this.effectiveRouting === "BetterDoc") {
        result =
          "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern dem medizinischen Fachpersonal von BetterDoc bereitzustellen und ";
      } else if (this.effectiveRouting.startsWith("ARAG Case Management")) {
        result =
          "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern den ARAG Gesundheitsassistenten " +
          this.aragRoutingSuffix +
          " bereitzustellen und ";
      } else if (this.effectiveRouting === "Quality Smile") {
        result =
          "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern dem Patientenservice von Quality Smile bereitzustellen und ";
      }
      result +=
        " dass meine personenbezogenen Daten von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt werden und nehme die ";
      return result;
    },
    personalDataPrivacyText() {
      // let result =
      //   "<p>Ihre Kontaktdaten (Anrede, Vorname, Nachname, Alter, Anschrift, Telefonnummer sowie E-Mail-Adresse) und die Versicherungsnummer Ihrer ARAG-Krankenversicherung werden von Roodie ";
      let result =
        "<p>Bei Ihren personenbezogenen Daten handelt es sich um Anrede, Vorname, Nachname, Alter, Anschrift, Telefonnummer sowie E-Mail-Adresse und die Versicherungsnummer Ihrer ARAG-Krankenversicherung. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von der ";

      // if (this.effectiveRouting === "BetterDoc") {
      //   result +=
      //     "an die BetterDoc GmbH zum Zweck der Kontaktaufnahme mit Ihnen und der Arzt-/Kliniksuche ";
      // } else if (this.effectiveRouting.startsWith("ARAG Case Management")) {
      //   result +=
      //     "an die ARAG Krankenversicherungs-AG zum Zweck der Unterstützung für Ihr gesundheitliches Anliegen und/oder Suche nach Gesundheitsdienstleistern ";
      // } else if (this.effectiveRouting === "Quality Smile") {
      //   result +=
      //     "an die Quality Smile GmbH  zum Zweck der Zahnarzt-/Zahnlaborsuche ";
      // }

      // result +=
      //   "weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von der ";

      if (this.effectiveRouting === "BetterDoc") {
        result += "BetterDoc GmbH ";
      } else if (this.effectiveRouting.startsWith("ARAG Case Management")) {
        result += "ARAG Krankenversicherungs-AG ";
      } else if (this.effectiveRouting === "Quality Smile") {
        result += "Quality Smile GmbH ";
      }

      // result +=
      //   "an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.";
      result +=
        "an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern.</p>";

      if (this.effectiveRouting === "BetterDoc") {
        result +=
          "<p>Bitte beachten Sie, dass bei Weiterleitung an die BetterDoc GmbH bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
      } else if (this.effectiveRouting === "Quality Smile") {
        result +=
          "<p>Bitte beachten Sie, dass bei Weiterleitung an die Quality Smile GmbH bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
      }

      // result += "</p>";
      return result;
    },
    filteredQuestions() {
      const result = [];
      for (const question of this.questions) {
        if (question.id !== "be-100") {
          result.push(question);
        } else {
          break;
        }
      }
      for (const answer of this.answers) {
        if (answer.isAdditionalAnswer) {
          const relatedQuestionIndex = result.findIndex((obj) => {
            return obj.id === answer.id.split(".")[0];
          });
          if (relatedQuestionIndex !== -1) {
            result.splice(relatedQuestionIndex + 1, 0, answer.question);
          }
        }
      }
      return result;
    },
    answersObject() {
      const result = {};
      for (const answer of this.answers) {
        result[answer.id] = answer;
      }
      return result;
    },
    name() {
      let result = this.routing;
      if (this.routing === "ZTK") {
        result = "Zahnärztliche Tageskliniken";
      }
      return result;
    },
    ztkBookingAnswer() {
      // return this.answers.find((obj) => obj.id === "zt-1");
      return this.answersObject["zt-1"];
    },
    ztkBookingLocation() {
      return this.answersObject["zt-4"]?.valueIds;
    },
    shouldOpenCoaching() {
      return this.answersObject["be-18"]?.value === "Ja";
    },
    shouldOpenFormContact() {
      return this.mental;
      // ||
      // [
      //   this.answersObject["be-4"]?.value,
      //   this.answersObject["be-4.1"]?.value,
      // ].includes("beides")
    },
    hasTreatmentplan() {
      return this.answersObject["be-19.1"]?.value !== "Keine Angabe";
    },
    // questionAnswers() {
    //   let result = [];
    //   for (const answer of this.answers) {
    //     const questionAnswer = {
    //       question: answer.question.text,
    //       answer: answer.value,
    //     };
    //     if (answer.base64) {
    //       questionAnswer.base64 = answer.base64;
    //     }
    //     result.push(questionAnswer);
    //   }
    //   return result;
    // },
  },
  setup() {
    return { pencilOutline, trashOutline, add, closeOutline };
  },
};
</script>

<style lang="scss">
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to,
.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
